import script from "./MollyProductDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./MollyProductDetail.vue?vue&type=script&setup=true&lang=ts"

import "./MollyProductDetail.vue?vue&type=style&index=0&id=dd835814&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd835814"]])

export default __exports__